export class DeleteIndexField {
    constructor(indexFieldRepository) {
      this.indexFieldRepository = indexFieldRepository;
    }
  
    async execute(IndexFieldListIds) {
      return await this.indexFieldRepository.DeleteIndexField(IndexFieldListIds);
    }
  }